import {combineReducers} from 'redux';
import common from './common';
import hrms from './hrms';
import attendance from './attendance';
import memorize from './memorize';
import setting from './setting';
import filter from './filters'
import onBoarding from './on-boarding'
import leave from './leave'
import storedFilter from './stored-filter'
import helpDesk from './help-desk'
import reimbursement from './reimbursement'

export default combineReducers({common, hrms, attendance, memorize, setting, filter, onBoarding, leave, storedFilter, helpDesk, reimbursement});
